import "core-js/modules/es.array.push.js";
import { mapState, mapMutations } from "vuex";
export default {
  methods: {
    repeatOrder() {
      this.$router.push({
        path: "/rol-shop/order",
        query: {
          repeat: this.orderNumber
        }
      });
    }
  },
  computed: {
    ...mapState({
      orderNumber: state => state.order.orderNumber
    })
  }
};